import { useContext, useState } from 'react';
import jwtDecode from 'jwt-decode';
import { AuthContext } from '../providers/AuthProvider';
import { getUser } from '../api/usersApi/usersApi';
import { UserRole, Permissions } from '../types';

// TODO: auth logic
const useAuth = () => {
  const { token, refreshToken, onLogOut, isAuth, changeAuth } = useContext(AuthContext);

  const [loading, setLoading] = useState<boolean>(true);

  const stopLoading = () => {
    setLoading(false);
  };

  const checkAuth = async () => {
    if (!token) {
      setLoading(false);
      return;
    }
    try {
      const userTokenData: { [key: string]: string } = jwtDecode(token);
      const res = await getUser(userTokenData.username);
      if (res.data) {
        localStorage.setItem('role', res.data.role);
        localStorage.setItem('firmId', res.data.firm.id);
        localStorage.setItem('userId', res.data.id.toString());
        if (res.data.roles && Array.isArray(res.data.roles) && res.data.roles.length > 0) {
          localStorage.setItem('userRole', (res.data.roles[0] as UserRole)?.roleName || '');
        }
        localStorage.setItem('userName', `${res.data.firstName} ${res.data.lastName}`);

        localStorage.setItem(
          'showUserOnboardingDetails',
          String(res.data.firm?.showUserOnboardingDetails ?? false),
        );
        localStorage.setItem(
          'hasSettlementApprovalFlow',
          String(res.data.firm?.hasSettlementApprovalFlow ?? false),
        );

        const accountingSystem = res.data.firm?.accountingSystem;
        if (!accountingSystem) {
          localStorage.removeItem('accountingSystem');
        } else {
          localStorage.setItem('accountingSystem', accountingSystem);
        }
        
        let updatedMergedPermissions: Permissions = {};
        // Merge and store permissions from all roles
        if (res.data.roles && Array.isArray(res.data.roles) && res.data.roles.length > 0) {
          const mergedPermissions: Permissions = {};
          res.data.roles.forEach((role: string | UserRole) => {
            if (typeof role === 'string') return;
            if (!role.permissions) return;
            const rolePerms = role.permissions;
            Object.keys(rolePerms).forEach((resource) => {
              if (!mergedPermissions[resource]) {
                mergedPermissions[resource] = {};
              }
              Object.keys(rolePerms[resource]).forEach((action) => {
                // If any role has the permission, grant it (OR logic)
                mergedPermissions[resource][action] =
                  mergedPermissions[resource][action] || rolePerms[resource][action];
              });
            });
          });
          updatedMergedPermissions = {
            ...mergedPermissions,
            // temporary override for Dashboard permissions to always allow all actions
            Dashboard: {
              View: true,
            },
          };

          localStorage.setItem('permissions', JSON.stringify(updatedMergedPermissions));
        } else {
          localStorage.removeItem('permissions');
        }
      }

      if (changeAuth) {
        changeAuth(true);
      }
    } finally {
      setLoading(false);
    }
  };

  return {
    token,
    refreshToken,
    onLogOut,
    isAuth,
    changeAuth,
    loading,
    stopLoading,
    checkAuth,
  };
};

export default useAuth;
